import { ReactNode, useState } from 'react'
import { Palette } from '@otsofintech/sofinx-ui/lib/style'
import CheckIcon from '@/assets/images/check-done.svg'
import InfoIcon from '@/assets/images/info-fill.svg'
import CopyIcon from '@/assets/images/copy.svg'
import ErrorOutlineIcon from '@/assets/images/error-outline.svg'

export type IconTypes = keyof typeof iconMap

type IconMap = {
  [name: string]: { icon: string, color: Palette }
}

export const iconMap: IconMap = {
  check: { icon: CheckIcon, color: 'primary' },
  error: { icon: InfoIcon, color: 'error2' },
  copy: { icon: CopyIcon, color: 'primary' },
  warning: { icon: ErrorOutlineIcon, color: 'warn2' },
  warning2: { icon: ErrorOutlineIcon, color: 'error2' },
}

export type Message = {
  icon: ReactNode | IconTypes
  message: ReactNode
  symbol?: Symbol
}

export let showMessage = (message: Message): void => {}

const useMessage = () => {
  const [message, setMessage] = useState<Message>({
    icon: 'check',
    message: '',
    symbol: Symbol(Date.now()),
  })

  showMessage = (message) => setMessage({ ...message, symbol: Symbol(Date.now()) })

  return {
    messager: message,
    setMessage
  }
}

export default useMessage
